export default __webpack_public_path__ + "static/img-double-peak-group-b046800144500f7cfa043ef555f51615.png";